import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MutationButton from './MutationButton';
import { extendedMutationType } from '../../types';

ApplyChangesButton.propTypes = {
    extendedMutation: extendedMutationType.isRequired,
    confirmationMessage: PropTypes.string.isRequired,
    extraConfirmationMessage: PropTypes.string,
    disabled: PropTypes.bool,
    showConfirmationDialog: PropTypes.bool,
};

ApplyChangesButton.defaultProps = {
    disabled: false,
    extraConfirmationMessage: null,
    showConfirmationDialog: false,
};

function ApplyChangesButton(props) {
    const {
        extendedMutation,
        confirmationMessage,
        extraConfirmationMessage,
        disabled,
        showConfirmationDialog,
    } = props;
    const { t } = useTranslation();
    return (
        <MutationButton
            className="apply-changes-button button-bordered button"
            confirmationMessage={confirmationMessage}
            extraConfirmationMessage={extraConfirmationMessage}
            disabled={disabled}
            extendedMutation={extendedMutation}
            showConfirmationDialog={showConfirmationDialog}
        >
            <FontAwesomeIcon icon="check" />&nbsp;{t('button.apply-changes')}
        </MutationButton>
    );
}

export default ApplyChangesButton;
